import { http } from '../utils/http'

// businessType 查询
const searchAction = (params, page, size) => {
    const url = `/config/businessTypeInfo/page`
    return http.post(url, params, page, size)
};

// businessType 新增
const addAction = (params) => {
    const url = `/config/businessTypeInfo/save`
    return http.post(url, params)
};

// businessType 删除
const delAction = (id) => {
    const url = `/config/businessTypeInfo/delete/${id}`
    return http.post(url)
};

export default {
    searchAction,
    addAction,
    delAction
  }